import React from "react";
import AppTheme from "../../utils/Theme";
import { Image, Platform, TouchableOpacity } from "react-native";
import { openUrl } from "../../utils/WebLink";
import User from "../../data/user/User";
import View from "../ReactNative/View";
import Text from "../ReactNative/Text";
import SVGView from "../../utils/SvgView";
import { IcArobas, IcInstagram } from "../../utils/Icons";
import { useSpecificSize } from "../../../specific/Theme/SpecificSize";

interface ContactFooterProps {

}

const ContactFooter = (props: ContactFooterProps) => {

    const appTheme: AppTheme = new AppTheme();
    const user: User = User.getInstance();

    const {
        contentSize,
        horizontalSpacing
    } = useSpecificSize();

    const trainingSectionWidth: number = contentSize - 2* horizontalSpacing;
    let imageSize: number = (trainingSectionWidth - appTheme.pixelPerfect(60)) / 5;
    if (imageSize > appTheme.pixelPerfect(60)) {
        imageSize = appTheme.pixelPerfect(60);
    }
    let title: string = "Rejoignez la communauté des super-profs";
    let savButton: React.JSX.Element | null = <TouchableOpacity onPress={() => openUrl("https://app.livestorm.co/lilicool/webinar-daccompagnement-a-la-pratique-de-lili")}>
        <Image resizeMode="contain" source={require("../../assets/img/rooms/ic_sav.png")} style={{ width: imageSize * 1.3, height: (imageSize * 1.3) * 380 / 563 }} />
    </TouchableOpacity>;
    if (user.profile === "animator") {
        title = "Rejoignez la communauté des super-anims";
    } else if (user.profile === "family") {
        title = "Rejoignez la communauté des super-parents";
        savButton = null;
    }
    return <View style={{ marginTop: appTheme.pixelPerfect(10), width: trainingSectionWidth, alignItems: "center" }}>
        <Text style={{ fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(12), textAlign: "center", textTransform: "uppercase", color: user.profile === "family" ? "#FFFFFF" : appTheme.darkBlue }}>{title}</Text>
        <View style={{ width: trainingSectionWidth, marginVertical: 20, flexDirection: "row", justifyContent: "space-between" }}>
            <TouchableOpacity onPress={() => openUrl("https://www.instagram.com/lili.cool.app/")} style={{ width: imageSize, height: imageSize, justifyContent: "center", alignItems: "center" }}>
                <View style={{ width: imageSize - 20, height: imageSize - 20, backgroundColor: appTheme.talk, borderRadius: (imageSize - 20) / 2, justifyContent: "center", alignItems: "center" }}>
                    <SVGView Component={IcInstagram} size={(imageSize - 20) / 2} color="#FFFFFF" />
                </View>
            </TouchableOpacity>
            <TouchableOpacity onPress={() => openUrl("https://www.lili.cool/fr/#bottom_nl")}>
                <Image resizeMode="contain" source={require("../../assets/img/rooms/ic_newsletter.png")} style={{ width: imageSize, height: imageSize * 216 / 204 }} />
            </TouchableOpacity>
            <TouchableOpacity onPress={() => openUrl("https://www.lili.cool/fr/le-blog-de-lili/")}>
                <Image resizeMode="contain" source={require("../../assets/img/rooms/ic_blog.png")} style={{ width: imageSize, height: imageSize * 190 / 203 }} />
            </TouchableOpacity>
            {savButton}
            <TouchableOpacity style={{ width: imageSize, height: imageSize, justifyContent: "center", alignItems: "center" }} onPress={() => openUrl("https://www.lili.cool/fr/contact/")}>
                <View style={{ width: imageSize - 20, height: imageSize - 20, backgroundColor: appTheme.talk, borderRadius: (imageSize - 20) / 2, justifyContent: "center", alignItems: "center" }}>
                    <SVGView Component={IcArobas} size={(imageSize - 20) / 2} color="#FFFFFF" />
                </View>
                <Image resizeMode="contain" source={require("../../assets/img/rooms/ic_plane.png")} style={{ width: imageSize / 2, height: imageSize / 2, position: "absolute", bottom: 0, right: 0 }} />
            </TouchableOpacity>
        </View>
    </View>
}

export default ContactFooter;

